import {
  CompositeInherit,
  Attribute,
  ParameterConfig,
  DataQuery,
  ValueSuggestionData,
  ValueAssociation,
  ValueCheck,
  ConfirmationInfo,
  PromptInfo,
  OriginKey,
  IntentInfo,
  CompositeInfo,
  EntityInfo,
  ProviderType,
  DbConfig,
  WebhookConfig,
  GoogleSheetsConfig,
  NativeConfig,
  ExternalType,
  ServiceSlot,
  ServiceInfo
} from '@interface/index';
import { AGENT_DEPLOY_MODE } from '@config/constants';
import { ModelDeclare, ModelProxy } from '@lib/model-proxy';
import { effects } from './effect';

// state
export interface StateInfo {
  id: string;
  source?: string;
  originKey?: OriginKey;
  structKey?: OriginKey;
  parameters: ParameterConfig[];
  availableIntents: IntentInfo[];
  availableComposites: CompositeInfo[];
  availableEntities: EntityInfo[];
  availableServices: ServiceInfo[];
  availableChannels: string[];
  selectedParameters: Attribute[];
  nestedSlotCustomizatoins: Attribute[];
  inheritedParameters: Attribute[];
  parent: any;
  dirty: boolean;
  err: boolean;
  name: string;
  comment?: string;
  showAdvanced: boolean;
  parentId?: string;
  dleStates: string[];
  saveLoading: boolean;
  loading: boolean;
  showParameterEditor: boolean;
  parameterEditorData: any;
  globalParameters: Attribute[];
  scope: string;
  readonly: boolean;
  isFromQuestion: boolean;
  selectedCompositeInherit?: CompositeInherit[];
  isInterface: boolean;
  psql: boolean;
  dataQueries: DataQuery[];
  services: ServiceSlot[];
  qualification: string;
  externalQualification: boolean;
  providerType?: ProviderType;
  deployMode?: AGENT_DEPLOY_MODE;
  sqlConfig?: DbConfig;
  webhookConfig?: WebhookConfig;
  googleSheetsConfig?: GoogleSheetsConfig;
  nativeConfig?: NativeConfig;
  externalTypes: ExternalType[];
  tab?: string;
  jsonInputVisible?: boolean;
  isImplementation?: boolean;
}

export type PayloadInfo = { [K in keyof StateInfo]: StateInfo[K] };

export const defaultState: PayloadInfo = {
  scope: '',
  id: '',
  parameters: [],
  availableIntents: [],
  availableComposites: [],
  availableEntities: [],
  availableServices: [],
  availableChannels: [],
  selectedParameters: [],
  nestedSlotCustomizatoins: [],
  inheritedParameters: [],
  dataQueries: [],
  services: [],
  showParameterEditor: false,
  parameterEditorData: [],
  globalParameters: [],
  parent: {},
  readonly: false,
  name: '',
  parentId: '',
  err: false,
  dirty: false,
  isInterface: false,
  psql: false,
  showAdvanced: false,
  dleStates: [],
  saveLoading: false,
  loading: false,
  isFromQuestion: false,
  qualification: '',
  externalQualification: false,
  externalTypes: []
};

const service: ModelDeclare = {
  effects,
  namespace: 'service',
  state: defaultState,
  actions: {
    clear: () => defaultState
  }
};

export const serviceModel = new ModelProxy<StateInfo, PayloadInfo>(service);
